import { ActionTypeKeys } from 'common/actions'
import Api from 'common/services/Api'
import Session from 'common/services/Session'

import { baseApiUrl } from 'embed/constants/config'

export const trackingMiddleware = (tracker, parent) => (store) => (next) => (action) => {
  if (action.trackingKey !== undefined) {
    tracker.trackEvent({
      action: action.trackingKey,
      data: action.trackingData || {},
      timestamp: action.timestamp || new Date(),
    })
  }

  if (action.publishKey !== undefined) {
    action.leadUuid = Session.getLeadUuid()
    action.sessionUuid = Session.sessionUuid
    parent.publishMessage(action.publishKey, action)
  }

  if (action.type === ActionTypeKeys.SESSION_INITIALIZED) {
    Api.post(`${baseApiUrl}/uiEvent/sessionInits`, { sessionUuid: action.sessionUuid })
  }

  next(action)
}
